/**
 * @file コンポーネント：フル動画ページタイムライン DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { TimelineItem } from "~/src/components/projects/Video/TimelineItem";
import { TimelineTopic } from "~/src/components/projects/Video/TimelineTopic";
import { Loading } from "~/src/components/uiparts/Loading";
import { Paragraph } from "~/src/components/uiparts/Paragraph";

// スタイル設定読み込み
import {
    StyledTimeline,
    StyledTimelineButton,
    StyledTimelineButtonIcon,
    StyledTimelineButtonText,
    StyledTimelineEditContainer,
    StyledTimelineEditText,
    StyledTimelineList,
    StyledTimelineListItem,
    StyledTimelineListItemMessage,
    StyledTimelineLoading,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledTimeline>
            {props.isLoadingTimeline && (
                // ローディング中
                <StyledTimelineLoading>
                    <Loading />
                </StyledTimelineLoading>
            )}
            {props.listTimeline && props.listTimeline.length > 0 && (
                // タイムラインがある場合
                <StyledTimelineList
                    className={props.isEditPage === true && "is-editpage"}
                    ref={props.refTimeline}
                >
                    {props.listTimeline.map((item) => (
                        <React.Fragment key={"item-" + item.id}>
                            {item.listTopic ? (
                                // トピックの場合
                                <TimelineTopic
                                    fnOnClickButton={props.fnOnClickButton}
                                    itemId={item.id}
                                    itemText={item.text}
                                    itemTime={item.time}
                                    listTopic={item.listTopic}
                                    mainSurgeonId={props.mainSurgeonId}
                                />
                            ) : (
                                // トピックではない場合
                                <StyledTimelineListItem>
                                    <TimelineItem
                                        fnOnClickButton={props.fnOnClickButton}
                                        fnSetModalEdit={props.fnSetModalEdit}
                                        isEditPage={props.isEditPage}
                                        isPaid={props.isPaid}
                                        isPurchased={props.isPurchased}
                                        itemId={item.id}
                                        itemText={item.text}
                                        itemTime={item.time}
                                        languageCodeOperation={
                                            props.languageCodeOperation
                                        }
                                        listDevice={item.listDevice}
                                        listSchema={item.listSchema}
                                        setClickedSlideIndex={
                                            props.setClickedSlideIndex
                                        }
                                        setIsHighlightPopupPayment={
                                            props.setIsHighlightPopupPayment
                                        }
                                        setIsOpenPopupSchema={
                                            props.setIsOpenPopupSchema
                                        }
                                        setPopupSchemaSlider={
                                            props.setPopupSchemaSlider
                                        }
                                        setSelectedContentsData={
                                            props.setSelectedContentsData
                                        }
                                        type={props.type}
                                    />
                                </StyledTimelineListItem>
                            )}
                        </React.Fragment>
                    ))}
                    {props.isPaid === true && props.isPurchased === false && (
                        // 有料コンテンツで未購入の場合
                        <StyledTimelineListItem>
                            <StyledTimelineListItemMessage>
                                {localized["Label.PurchaseToSeeFullTimeline"]}
                            </StyledTimelineListItemMessage>
                        </StyledTimelineListItem>
                    )}
                    {!window.dataUser.isLogin && (
                        // 未ログインの場合
                        <StyledTimelineListItem>
                            <StyledTimelineListItemMessage>
                                {localized["Label.LoginToSeeFullTimeline"]}
                            </StyledTimelineListItemMessage>
                        </StyledTimelineListItem>
                    )}
                </StyledTimelineList>
            )}
            {!props.isLoadingTimeline &&
                props.listTimeline &&
                props.listTimeline.length === 0 && (
                    // タイムラインがない場合
                    <>
                        {props.type === "comment" && (
                            // コメントの場合
                            <Paragraph
                                onColor="sub"
                                text={localized["Message.NoComments"]}
                            />
                        )}
                        {props.type === "event" && (
                            // イベントの場合
                            <Paragraph
                                onColor="sub"
                                text={localized["Message.NoEvents"]}
                            />
                        )}
                    </>
                )}
            {props.isEditPage === true && (
                // 執刀医権限フル動画ページの場合のみ
                <StyledTimelineEditContainer
                    data-edit-language={props.languageCodeOperation}
                >
                    {props.languageCodeOperation === "en" && (
                        <StyledTimelineEditText>
                            {localized["Label.UneditableEnglishData"]}
                        </StyledTimelineEditText>
                    )}
                    <StyledTimelineButton
                        disabled={props.languageCodeOperation === "en"}
                        onClick={(e) =>
                            props.fnSetModalEdit(e, props.type, "add", {
                                time: props.timeProgress,
                            })
                        }
                    >
                        <StyledTimelineButtonIcon>
                            <i className="fas fa-plus"></i>
                        </StyledTimelineButtonIcon>
                        <StyledTimelineButtonText>
                            {props.type === "comment" &&
                                localized["Label.AddComment"]}
                            {props.type === "event" &&
                                localized["Label.AddEvent"]}
                        </StyledTimelineButtonText>
                    </StyledTimelineButton>
                </StyledTimelineEditContainer>
            )}
        </StyledTimeline>
    );
};
